import PriceLockup from './PriceLockup';
export default PriceLockup;